import { render, staticRenderFns } from "./MateriaPrima.vue?vue&type=template&id=1fb46008&scoped=true&"
import script from "./MateriaPrima.vue?vue&type=script&lang=js&"
export * from "./MateriaPrima.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb46008",
  null
  
)

export default component.exports